import { useLauncherStore } from "@/app/[tenantId]/[messengerId]/[hostConfig]/lib/client/contexts/LauncherStoreContext";

export default function useHasFooter() {
  const config = useLauncherStore((state) => state.config);

  const routes = config?.routes;
  const hidePoweredBy = config?.settings?.displaySettings?.hidePoweredBy;
  return (routes && routes.length > 1) || !hidePoweredBy;
}
